import { Injectable } from '@angular/core';
import { RouterModule, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { SharingDataService } from '../app/service/sharing-data.service';


@Injectable()
export class CommonAuthGuard  {
  constructor(private router: Router, public sharingDataService: SharingDataService) {

  }


  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (window.localStorage.getItem('authToken') ) {

      if(window.localStorage.getItem('mobileNumber') && window.localStorage.getItem('email')){
        return true;
      } else{
        this.router.navigate(['/complete-profile'])
      }
      
    } else {
      console.log(state.url);
      this.sharingDataService.getReturnUrl(state.url);
      this.router.navigate(['/login']);
      return false;

    }


  }

}